import { getWeekTime, transferDate } from '@/utils/index.js'
import { getDateRegion } from '@/common/util.js'

function reportDateControl() {
  return {
    data() {
      return {
        avatarUrl: '',
        serviceId: '',
        websiteList: [],
        pickerType: 'week',
        selecttimetype: 'WEEKLY',
        format: 'yyyy 第 WW 周',
        startDate: '',
        endDate: '',
        selecttime: '',
        dataPeriod: '前一周',
        DailyOlData: '',
        WeeklyOlData: '',
        MonthlyOlData: '',
      }
    },

    methods: {
      // 切换网站
      changeSite(serviceId) {
        this.serviceId = serviceId
        let webItem = this.websiteList.find(
          (item) => item.serviceId === serviceId
        )
        this.avatarUrl = webItem.pageAvatar
        this.getChartDataAll()
      },
      // 时间类型选择
      change(val) {
        this.selecttime = ''
        this.selecttimetype = val
        switch (val) {
          case 'WEEKLY':
            this.pickerType = 'week'
            this.format = 'yyyy 第 WW 周'
            this.dataPeriod = '前一周'

            if (this.WeeklyOlData) {
              this.dataChange(this.WeeklyOlData)
            } else {
              this.getWeek()
              this.setCondition()
              this.setConditionPie()
            }
            break
          case 'DAILY':
            this.pickerType = 'date'
            this.format = 'yyyy-MM-dd'
            this.dataPeriod = '前一天'

            if (this.DailyOlData) {
              this.dataChange(this.DailyOlData)
            } else {
              this.getDetailDay()
              this.getChartDataAll()
              this.setConditionPie()
              this.setCondition()
            }
            break
          case 'MONTHLY':
            this.pickerType = 'month'
            this.format = 'yyyy-MM'
            this.dataPeriod = '前一月'

            if (this.MonthlyOlData) {
              this.dataChange(this.MonthlyOlData)
            } else {
              this.getDetailMonth()
              this.getChartDataAll()
              this.setCondition()
              this.setConditionPie()
            }
            break
          default:
            this.pickerType = 'week'
            break
        }
      },
      // 时间选择
      dataChange(val) {
        if (!val) {
          this.getWeek()
          return false
        }
        let { selecttimetype } = this
        // 周报
        if (selecttimetype === 'WEEKLY') {
          this.WeeklyOlData = val
          // 处理月份结束日期
          let weekEnd = val.getTime() + 6 * 24 * 3600 * 1000
          weekEnd = transferDate(new Date(weekEnd))
          let time = transferDate(val)

          this.startDate = time
          this.endDate = weekEnd
        }
        // 日报
        if (selecttimetype === 'DAILY') {
          this.DailyOlData = val
          let time = transferDate(val)

          this.startDate = time
          this.endDate = time
        }
        // 月报
        if (selecttimetype === 'MONTHLY') {
          this.MonthlyOlData = val
          let time = transferDate(val)
          // 求指定月长度
          let M = val.getMonth() + 1
          let Y = val.getFullYear()
          let lange = new Date(Y, M, 0).getDate()

          // 处理月份结束日期
          let arr = time.split('-')
          arr[2] = lange - 0

          this.startDate = time
          this.endDate = arr.join('-')
        }
        this.getChartDataAll()
        this.setCondition()
        this.setConditionPie()
      },
      // 获取时间初始值
      getWeek() {
        this.startDate = getWeekTime('start')
        this.endDate = getWeekTime('end')
        this.getChartDataAll()
      },
      // 日报初始化
      getDetailDay() {
        this.startDate = getDateRegion('DAY').split('至')[0]
        this.endDate = getDateRegion('DAY').split('至')[1]
      },
      // 月报初始化
      getDetailMonth() {
        this.startDate = getDateRegion('NEWMONTH').split('至')[0]
        this.endDate = getDateRegion('NEWMONTH').split('至')[1]
      },
    },
  }
}

export default reportDateControl
